<template lang="pug">
.medical-history
  v-overlay(v-if="update", :value="overlay")
    v-progress-circular(indeterminate, size="64")
  v-card
    v-toolbar(color="primary", dark, flat)
      v-toolbar-title {{ update ? 'Actualizar' : 'Creación de' }} Historial Médico
    .alert(v-if="messages_error_request")
      v-alert(border="top", color="red lighten-2", dark)
        ul
          li(v-for="message in messages_error_request") {{ message }}
    v-card-text
      ValidationObserver(
        ref="observer_medicalHistory_data",
        v-slot="{ validate, reset }"
      )
        v-form
          v-row
            v-col(cols="12", sm="12")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="pet"
              )
                v-autocomplete(
                  v-model="pet",
                  label="Mascota",
                  type="text",
                  :items="pets",
                  item-text="code",
                  item-value="id",
                  :error-messages="errors",
                  clearable,
                  required
                )
                  template(v-slot:item='data')
                    v-list-item-icon
                      v-chip(color="primary")
                        label.white--text {{ data.item.name }}
                    v-list-item-content
                      v-list-item-title(v-html='data.item.code')
          v-row
            v-col(cols="12", md="12")
              h3 Estado Mascota
          v-row
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="body_condition"
              )
                v-autocomplete(
                  v-model="status_pet.body_condition",
                  label="Condición Cuerpo",
                  :items="choices.body_condition",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="hydration_status"
              )
                v-autocomplete(
                  v-model="status_pet.hydration_status",
                  label="Hidratación",
                  :items="choices.hydration_status",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Conjuntivitis
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.conjunctiva.N", label="N")
              v-checkbox(v-model="status_pet.conjunctiva.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="observations"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.conjunctiva.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Oral
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.oral.N", label="N")
              v-checkbox(v-model="status_pet.oral.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="observations"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.oral.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Rectal
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.rectal.N", label="N")
              v-checkbox(v-model="status_pet.rectal.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.rectal.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Partes Privadas
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.private_parts.N", label="N")
              v-checkbox(v-model="status_pet.private_parts.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.private_parts.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Ojos
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.eyes.N", label="N")
              v-checkbox(v-model="status_pet.eyes.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.eyes.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Oidos
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.ears.N", label="N")
              v-checkbox(v-model="status_pet.ears.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.ears.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Piel
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.skin.N", label="N")
              v-checkbox(v-model="status_pet.skin.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.skin.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Nodos Linfáticos
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.lymph_nodes.N", label="N")
              v-checkbox(v-model="status_pet.lymph_nodes.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.lymph_nodes.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Motora
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.locomotion.N", label="N")
              v-checkbox(v-model="status_pet.locomotion.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.locomotion.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Musculo Esqueletico
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.skeletal_muscle.N", label="N")
              v-checkbox(v-model="status_pet.skeletal_muscle.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.skeletal_muscle.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Sistema Nervioso
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.nervous_system.N", label="N")
              v-checkbox(v-model="status_pet.nervous_system.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.nervous_system.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Sistema Cardiovascular
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.cardiovascular.N", label="N")
              v-checkbox(v-model="status_pet.cardiovascular.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.cardiovascular.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Sistema Respiratorio
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.respiratory.N", label="N")
              v-checkbox(v-model="status_pet.respiratory.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.respiratory.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición Sistema Digestivo
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.digestive.N", label="N")
              v-checkbox(v-model="status_pet.digestive.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.digestive.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Condición GenitoUrinario
          v-row
            v-col(cols="12", md="1")
              v-checkbox(v-model="status_pet.genitourinary.N", label="N")
              v-checkbox(v-model="status_pet.genitourinary.A", label="A")
            v-col(cols="12", md="11")
              ValidationProvider(
                v-slot="{ errors }",
                name="observations",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="status_pet.genitourinary.observations",
                  label="Observaciones",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Lista de Problemas
          v-row
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="problems",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="list_problems.problems",
                  label="Problemas",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="master",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="list_problems.master",
                  label="Master",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="differential_diagnosis",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="list_problems.differential_diagnosis",
                  label="Diagnostico Diferencial",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Plan Diagnóstico
          v-row
            v-col(cols="12", md="6")
              v-checkbox(v-model="diagnosis_plan.exam", label="Exámen")
            v-col(cols="12", md="6")
              v-checkbox(
                v-model="diagnosis_plan.authorized",
                label="Autorizado"
              )
          v-row
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="lab"
              )
                v-text-field(
                  v-model="diagnosis_plan.lab",
                  label="Laboratorio",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="results",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="diagnosis_plan.results",
                  label="Resultados",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", sm="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Fecha"
              )
                v-menu(
                  v-model="menu_date",
                  :close-on-content-click="false",
                  transition="scale-transition",
                  offset-y,
                  max-width="290px",
                  min-width="290px"
                )
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="dateFormatted",
                      label="Fecha",
                      clearable,
                      persistent-hint,
                      readonly,
                      v-on="on",
                      @click:clear="date = null"
                    )
                  v-date-picker(
                    v-model="date",
                    no-title,
                    @input="menu_date = false"
                  )
            v-col(cols="12", sm="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Hora"
              )
                v-menu(
                  v-model="menu_time",
                  :close-on-content-click="false",
                  transition="scale-transition",
                  offset-y,
                  max-width="290px",
                  min-width="290px"
                )
                  template(v-slot:activator="{ on }")
                    v-text-field(
                      v-model="timeFormatted",
                      label="Hora",
                      clearable,
                      persistent-hint,
                      readonly,
                      v-on="on",
                      @click:clear="time = null"
                    )
                  v-time-picker(
                    v-model="time",
                    ampm-in-title,
                    @input="menu_time = false"
                  )
          v-row
            v-col(cols="12", md="12")
              h3 Plan Terapeutico
          v-row
            v-col(cols="12", sm="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="type_plan_therapeutic"
              )
                v-autocomplete(
                  v-model="therapeutic_plan.type_plan_therapeutic",
                  label="Plan Terapeutico",
                  type="text",
                  :items="choices.type_plan_therapeutic",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  clearable,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="active_beginning",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="therapeutic_plan.active_beginning",
                  label="Comienzo Activo",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="presentation",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="therapeutic_plan.presentation",
                  label="Presentación",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="posology",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="therapeutic_plan.posology",
                  label="Posología",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="total_dose"
              )
                v-text-field(
                  v-model="therapeutic_plan.total_dose",
                  label="Dosis Total",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="way_dose"
              )
                v-text-field(
                  v-model="therapeutic_plan.way_dose",
                  label="Vía Administración",
                  type="text",
                  :error-messages="errors",
                  clearable,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="frequency_duration",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="therapeutic_plan.frequency_duration",
                  label="Duración",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
          v-row
            v-col(cols="12", md="12")
              h3 Interpretación
          v-row
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="result_interpretation",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="interpretation.result_interpretation",
                  label="Resultado Interpretación",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
            v-col(cols="12", md="12")
              ValidationProvider(
                v-slot="{ errors }",
                name="impression_diagnostic",
                rules="required"
              )
                v-textarea(
                  outlined,
                  v-model="interpretation.impression_diagnostic",
                  label="Impresión Diagnostica",
                  :items="choices.observations",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  no-resize=false,
                  height=120,
                  single-line,
                  hide-details,
                  required
                )
      v-card-actions
        v-spacer
        v-btn(
          color="secondary",
          @click="createUpdateMedicalHistory",
          :loading="loading",
          :disabled="loading"
        ) Guardar
</template>

<script>
import moment from "moment";
import medicalHistoryAPI from "@/api/medicalHistory";
import utils from "@/resources/utils";
import { mapGetters, mapState } from "vuex";
import { required, min, numeric, image } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío"
});

extend("min", {
  ...min,
  message: "{_field_} no puede ser menor que {length} caracteres"
});

extend("numeric", {
  ...numeric,
  message: "{_field_} solo admite números"
});

export default {
  name: "createUpdateMedicalHistory",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    update: {
      type: Boolean,
      required: false,
      default: false
    },
    id_medicalHistory: {
      type: Number | String,
      required: false,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      choices: "selectChoices"
    }),
    ...mapState({
      pets: state => state.pets.pet_without_pag,
      auth_token: state => state.auth.auth_token
    }),
    dateFormatted() {
      return this.date
        ? moment(this.date)
            .locale("es")
            .format("LL")
        : "";
    },
    timeFormatted() {
      return this.time ? this.time : "";
    }
  },
  async created() {
    if (this.update) {
      const response = await medicalHistoryAPI.getMedicalHistory(
        this.id_medicalHistory,
        this.auth_token
      );
      this.overlay = false;
      if (response.status) {
        this.pet = response.data.pet;
        this.status_pet.body_condition =
          response.data.status_pet.body_condition;
        (this.status_pet.hydration_status =
          response.data.status_pet.hydration_status),
          (this.status_pet.conjunctiva.N =
            response.data.status_pet.conjunctiva.N);
        this.status_pet.conjunctiva.A = response.data.status_pet.conjunctiva.A;
        this.status_pet.conjunctiva.observations =
          response.data.status_pet.conjunctiva.observations;
        this.status_pet.oral.N = response.data.status_pet.oral.N;
        this.status_pet.oral.A = response.data.status_pet.oral.A;
        this.status_pet.oral.observations =
          response.data.status_pet.oral.observations;
        this.status_pet.rectal.N = response.data.status_pet.rectal.N;
        this.status_pet.rectal.A = response.data.status_pet.rectal.A;
        this.status_pet.rectal.observations =
          response.data.status_pet.rectal.observations;
        this.status_pet.private_parts.N =
          response.data.status_pet.private_parts.N;
        this.status_pet.private_parts.A =
          response.data.status_pet.private_parts.A;
        this.status_pet.private_parts.observations =
          response.data.status_pet.private_parts.observations;
        this.status_pet.eyes.N = response.data.status_pet.eyes.N;
        this.status_pet.eyes.A = response.data.status_pet.eyes.A;
        this.status_pet.eyes.observations =
          response.data.status_pet.eyes.observations;
        this.status_pet.ears.N = response.data.status_pet.ears.N;
        this.status_pet.ears.A = response.data.status_pet.ears.A;
        this.status_pet.ears.observations =
          response.data.status_pet.ears.observations;
        this.status_pet.skin.N = response.data.status_pet.skin.N;
        this.status_pet.skin.A = response.data.status_pet.skin.A;
        this.status_pet.skin.observations =
          response.data.status_pet.skin.observations;
        this.status_pet.lymph_nodes.N = response.data.status_pet.lymph_nodes.N;
        this.status_pet.lymph_nodes.A = response.data.status_pet.lymph_nodes.A;
        this.status_pet.lymph_nodes.observations =
          response.data.status_pet.lymph_nodes.observations;
        this.status_pet.locomotion.N = response.data.status_pet.locomotion.N;
        this.status_pet.locomotion.A = response.data.status_pet.locomotion.A;
        this.status_pet.locomotion.observations =
          response.data.status_pet.locomotion.observations;
        this.status_pet.skeletal_muscle.N =
          response.data.status_pet.skeletal_muscle.N;
        this.status_pet.skeletal_muscle.A =
          response.data.status_pet.skeletal_muscle.A;
        this.status_pet.skeletal_muscle.observations =
          response.data.status_pet.skeletal_muscle.observations;
        this.status_pet.nervous_system.N =
          response.data.status_pet.nervous_system.N;
        this.status_pet.nervous_system.A =
          response.data.status_pet.nervous_system.A;
        this.status_pet.nervous_system.observations =
          response.data.status_pet.nervous_system.observations;
        this.status_pet.cardiovascular.N =
          response.data.status_pet.cardiovascular.N;
        this.status_pet.cardiovascular.A =
          response.data.status_pet.cardiovascular.A;
        this.status_pet.cardiovascular.observations =
          response.data.status_pet.cardiovascular.observations;
        this.status_pet.respiratory.N = response.data.status_pet.respiratory.N;
        this.status_pet.respiratory.A = response.data.status_pet.respiratory.A;
        this.status_pet.respiratory.observations =
          response.data.status_pet.respiratory.observations;
        this.status_pet.digestive.N = response.data.status_pet.digestive.N;
        this.status_pet.digestive.A = response.data.status_pet.digestive.A;
        this.status_pet.digestive.observations =
          response.data.status_pet.digestive.observations;
        this.status_pet.genitourinary.N =
          response.data.status_pet.genitourinary.N;
        this.status_pet.genitourinary.A =
          response.data.status_pet.genitourinary.A;
        this.status_pet.genitourinary.observations =
          response.data.status_pet.genitourinary.observations;
        this.list_problems.problems = response.data.list_problems.problems;
        this.list_problems.master = response.data.list_problems.master;
        this.list_problems.differential_diagnosis =
          response.data.list_problems.differential_diagnosis;
        this.diagnosis_plan.exam = response.data.diagnosis_plan.exam;
        this.diagnosis_plan.authorized =
          response.data.diagnosis_plan.authorized;
        this.date = response.data.diagnosis_plan.date.split("T")[0];
        this.time = response.data.diagnosis_plan.date
          .split("T")[1]
          .split("-")[0];
        this.diagnosis_plan.lab = response.data.diagnosis_plan.lab;
        this.diagnosis_plan.results = response.data.diagnosis_plan.results;
        this.therapeutic_plan.type_plan_therapeutic =
          response.data.therapeutic_plan.type_plan_therapeutic;
        this.therapeutic_plan.active_beginning =
          response.data.therapeutic_plan.active_beginning;
        this.therapeutic_plan.presentation =
          response.data.therapeutic_plan.presentation;
        this.therapeutic_plan.posology =
          response.data.therapeutic_plan.posology;
        this.therapeutic_plan.total_dose =
          response.data.therapeutic_plan.total_dose;
        this.therapeutic_plan.way_dose =
          response.data.therapeutic_plan.way_dose;
        this.therapeutic_plan.frequency_duration =
          response.data.therapeutic_plan.frequency_duration;
        this.interpretation.result_interpretation =
          response.data.interpretation.result_interpretation;
        this.interpretation.impression_diagnostic =
          response.data.interpretation.impression_diagnostic;
      } else {
        this.$swal({
          icon: "warning",
          title: response.data
        });
      }
    }
  },
  data() {
    return {
      messages_error_request: null,
      loading: false,
      menu_date: false,
      menu_time: false,
      date: null,
      time: null,
      pet: null,
      overlay: true,
      status_pet: {
        body_condition: null,
        hydration_status: null,
        conjunctiva: {
          N: false,
          A: false,
          observations: null
        },
        oral: {
          N: false,
          A: false,
          observations: null
        },
        rectal: {
          N: false,
          A: false,
          observations: null
        },
        private_parts: {
          N: false,
          A: false,
          observations: null
        },
        eyes: {
          N: false,
          A: false,
          observations: null
        },
        ears: {
          N: false,
          A: false,
          observations: null
        },
        skin: {
          N: false,
          A: false,
          observations: null
        },
        lymph_nodes: {
          N: false,
          A: false,
          observations: null
        },
        locomotion: {
          N: false,
          A: false,
          observations: null
        },
        skeletal_muscle: {
          N: false,
          A: false,
          observations: null
        },
        nervous_system: {
          N: false,
          A: false,
          observations: null
        },
        cardiovascular: {
          N: false,
          A: false,
          observations: null
        },
        respiratory: {
          N: false,
          A: false,
          observations: null
        },
        digestive: {
          N: false,
          A: false,
          observations: null
        },
        genitourinary: {
          N: false,
          A: false,
          observations: null
        }
      },
      list_problems: {
        problems: null,
        master: null,
        differential_diagnosis: null
      },
      diagnosis_plan: {
        exam: false,
        authorized: false,
        date: null,
        lab: null,
        results: null
      },
      therapeutic_plan: {
        type_plan_therapeutic: null,
        active_beginning: null,
        presentation: null,
        posology: null,
        total_dose: null,
        way_dose: null,
        frequency_duration: null
      },
      interpretation: {
        result_interpretation: null,
        impression_diagnostic: null
      }
    };
  },
  methods: {
    async createUpdateMedicalHistory() {
      this.messages_error_request = null;
      if (await this.$refs.observer_medicalHistory_data.validate()) {
        this.loading = true;
        this.diagnosis_plan.date = `${this.date} ${this.time}`;
        if (this.update) {
          const response = await medicalHistoryAPI.updateMedicalHistories(
            this.id_medicalHistory,
            {
              pet: this.pet,
              status_pet: this.status_pet,
              list_problems: this.list_problems,
              diagnosis_plan: this.diagnosis_plan,
              therapeutic_plan: this.therapeutic_plan,
              interpretation: this.interpretation
            },
            this.auth_token
          );
          response.status
            ? await this.getMedicalHistories(this.update)
            : this.$swal({
                icon: "success",
                title: response.data
              });
        } else {
          const response = await medicalHistoryAPI.createMedicalHistories(
            {
              pet: this.pet,
              status_pet: this.status_pet,
              list_problems: this.list_problems,
              diagnosis_plan: this.diagnosis_plan,
              therapeutic_plan: this.therapeutic_plan,
              interpretation: this.interpretation
            },
            this.auth_token
          );
          response.status
            ? await this.getMedicalHistories(this.update)
            : this.$swal({
                icon: "warning",
                title: response.data
              });
        }
        this.loading = false;
      }
    },
    async getMedicalHistories(action) {
      let title = "";
      action ? (title = "Actualizado") : (title = "Creado");
      this.$swal({
        title: `Historial Médico ${title}`,
        icon: "success"
      });
      await this.$store.dispatch("medicalHistory/getMedicalHistories", {
        token: this.auth_token,
        page: 1
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  padding: 15px;
}
</style>
